import TDropdown from './dropdown.vue'
import TDropdownMenu from './dropdown-menu.vue'
import TDropdownItem from './dropdown-item.vue'
TDropdown.Menu = TDropdownMenu
TDropdown.Item = TDropdownItem
export default TDropdown



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js